export default "__VITE_ASSET__TUtkI$EP__"